import { combineReducers } from "redux";
import _ from "lodash";
import { API } from "../../../../const";
import { Service } from "../../../service/service";
import {
  OPEN_SNACKBAR_ERROR,
  OPEN_SNACKBAR_SUCCESS,
} from "../../../../reducers";
import { unAuthorized } from "../../../auth/Auth.ducks";

export const PUT_INFO_CRECHE_PENDING = "PUT_INFO_CRECHE_PENDING";
export const PUT_INFO_CRECHE_REJECTED = "PUT_INFO_CRECHE_REJECTED";
export const PUT_INFO_CRECHE_FULFILLED = "PUT_INFO_CRECHE_FULFILLED";

export const PUT_LOGO_CRECHE_PENDING = "PUT_LOGO_CRECHE_PENDING";
export const PUT_LOGO_CRECHE_REJECTED = "PUT_LOGO_CRECHE_REJECTED";
export const PUT_LOGO_CRECHE_FULFILLED = "PUT_LOGO_CRECHE_FULFILLED";

export const GET_INFO_CRECHE_PENDING = "GET_INFO_CRECHE_PENDING";
export const GET_INFO_CRECHE_REJECTED = "GET_INFO_CRECHE_REJECTED";
export const GET_INFO_CRECHE_FULFILLED = "GET_INFO_CRECHE_FULFILLED";

const loading = (state = false, { type }) => {
  switch (type) {
    case GET_INFO_CRECHE_PENDING:
    case PUT_INFO_CRECHE_PENDING:
    case PUT_LOGO_CRECHE_PENDING:
      return true;
    case GET_INFO_CRECHE_REJECTED:
    case GET_INFO_CRECHE_FULFILLED:
    case PUT_INFO_CRECHE_REJECTED:
    case PUT_INFO_CRECHE_FULFILLED:
    case PUT_LOGO_CRECHE_REJECTED:
    case PUT_LOGO_CRECHE_FULFILLED:
      return false;
    default:
      return state;
  }
};

const error = (state = {}, { type, payload }) => {
  switch (type) {
    case PUT_INFO_CRECHE_PENDING:
    case PUT_INFO_CRECHE_FULFILLED:
    case GET_INFO_CRECHE_PENDING:
    case GET_INFO_CRECHE_FULFILLED:
    case PUT_LOGO_CRECHE_PENDING:
    case PUT_LOGO_CRECHE_FULFILLED:
      return null;
    case PUT_INFO_CRECHE_REJECTED:
    case GET_INFO_CRECHE_REJECTED:
    case PUT_LOGO_CRECHE_REJECTED:
      return payload;
    default:
      return null;
  }
};

const data = (state = {}, { type, payload }) => {
  switch (type) {
    case GET_INFO_CRECHE_FULFILLED:
      return _.isEmpty(payload.data) ? null : payload.data;
    default:
      return state;
  }
};

export default combineReducers({ loading, error, data });

export const getInfosCreche = (tok) => {
  return (dispatch) => {
    dispatch({ type: GET_INFO_CRECHE_PENDING });
    const response = Service.get(`${API}api/creche/creche`, {
      headers: { Authorization: `Bearer ${tok}` },
    });
    response.then((res) => {
      dispatch({ type: GET_INFO_CRECHE_FULFILLED, payload: res });
    });
    response.catch((err) => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message });
      dispatch({ type: GET_INFO_CRECHE_REJECTED, payload: err });
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized());
      }
    });
  };
};

export const putInfosCreche = (tok, data) => {
  return (dispatch) => {
    dispatch({ type: PUT_INFO_CRECHE_PENDING });
    const response = Service.put(`${API}api/creche/creche`, data, {
      headers: { Authorization: `Bearer ${tok}` },
    });
    response.then((res) => {
      dispatch({ type: PUT_INFO_CRECHE_FULFILLED, payload: res });
      dispatch({ type: OPEN_SNACKBAR_SUCCESS });
      dispatch(getInfosCreche(tok));
    });
    response.catch((err) => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: PUT_INFO_CRECHE_REJECTED, payload: err });
      dispatch({ type: OPEN_SNACKBAR_ERROR, payload: message });
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized());
      }
    });
  };
};

export const updateLogoCreche = (tok, idLogo) => {
  return (dispatch) => {
    const response = Service.put(`${API}api/creche/creche/logo`, {idLogo: idLogo}, { headers: { Authorization: `Bearer ${tok}` } })
    response.then((res) => {
      dispatch({ type: PUT_LOGO_CRECHE_FULFILLED, payload: res })
      dispatch(getInfosCreche(tok))

    })
    response.catch(err => {
      let message = !_.isEmpty(err.response) ? err.response.data.message : null;
      dispatch({ type: "OPEN_SNACKBAR_ERROR", payload: message })
      dispatch({ type: PUT_LOGO_CRECHE_REJECTED, payload: err })
      if (err && err.response && err.response.status === 401) {
        dispatch(unAuthorized())
      }
    })
  }
}
